import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {HelpContentModule} from '../../common/help-content/help-content.module';
import {HelpNavBackModule} from '../../common/help-nav-back/help-nav-back.module';
import {HelpRecordLatencyContentComponent} from './help-record-latency-content/help-record-latency-content.component';
import {HelpRecordLatencyComponent} from './help-record-latency.component';

@NgModule({
  declarations: [HelpRecordLatencyComponent, HelpRecordLatencyContentComponent],
  exports: [HelpRecordLatencyComponent, HelpRecordLatencyContentComponent],
  imports: [CommonModule, HelpContentModule, HelpNavBackModule, MatIconModule, MatTooltipModule, MatButtonModule]
})
export class HelpRecordLatencyModule {}
